import { useTranslation } from "react-i18next";
import styled from "styled-components/macro";
import { useMdmEntityDisplayNames } from "../../util/mdmEntityDisplayNames";

const Wrapper = styled.span`
  width: fit-content;
`;

const ObjectReferenceMeta = styled.span`
  display: block;
  overflow: hidden;
  color: ${({ theme }) => theme.resolve("color_text_tertiary")};
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  line-height: ${({ theme }) => theme.resolve("line_height_sm")};
`;

export function AttributeTypeDisplayOnList({
  sourceObjectType,
  targetObjectType,
}: {
  sourceObjectType?: string;
  targetObjectType?: string;
}) {
  const { t } = useTranslation();
  const { getObjectTypeLabel } = useMdmEntityDisplayNames();

  return (
    <Wrapper>
      <ObjectReferenceMeta>
        {t("Source")}: {getObjectTypeLabel(sourceObjectType)} • {t("Target")}:{" "}
        {getObjectTypeLabel(targetObjectType)}
      </ObjectReferenceMeta>
    </Wrapper>
  );
}
